import { QueryClient } from '@tanstack/react-query';

/**
 * Konfigurert QueryClient for React Query
 * 
 * Standard konfigurasjon:
 * - staleTime: 5 minutter (data anses som fersk)
 * - cacheTime: 10 minutter (hvor lenge inaktiv data beholdes)
 * - retry: 1 forsøk (ikke for mange forsøk på feil)
 * - refetchOnWindowFocus: false (ikke automatisk refetch ved fokus)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutter
      gcTime: 10 * 60 * 1000, // 10 minutter (erstatter cacheTime i v5)
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0, // Ikke retry mutations automatisk
    },
  },
});

